import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var ListNode = /*#__PURE__*/function () {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function ListNode(id, value, prev, next) {
    _classCallCheck(this, ListNode);
    _defineProperty(this, "value", void 0);
    _defineProperty(this, "id", void 0);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _defineProperty(this, "nextNode", void 0);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _defineProperty(this, "prevNode", void 0);
    this.id = id;
    this.value = value;
    this.prevNode = prev;
    this.nextNode = next;
  }
  _createClass(ListNode, [{
    key: "next",
    value: function next() {
      return this.nextNode;
    }
  }, {
    key: "prev",
    value: function prev() {
      return this.prevNode;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "setNext",
    value: function setNext(node) {
      this.nextNode = node;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "setPrev",
    value: function setPrev(node) {
      this.prevNode = node;
    }
  }]);
  return ListNode;
}();